__turbopack_context__.v({
  "card_link": "HeroProgramSectionSliders-module-scss-module__wjOECa__card_link",
  "degree_info_section": "HeroProgramSectionSliders-module-scss-module__wjOECa__degree_info_section",
  "imgLogoAbsolute": "HeroProgramSectionSliders-module-scss-module__wjOECa__imgLogoAbsolute",
  "imgLogoAbsolutePMI": "HeroProgramSectionSliders-module-scss-module__wjOECa__imgLogoAbsolutePMI",
  "imgLogoAbsoluteRics": "HeroProgramSectionSliders-module-scss-module__wjOECa__imgLogoAbsoluteRics",
  "imgLogoAbsoluteWomen": "HeroProgramSectionSliders-module-scss-module__wjOECa__imgLogoAbsoluteWomen",
  "img_section": "HeroProgramSectionSliders-module-scss-module__wjOECa__img_section",
  "medvarsity_logo": "HeroProgramSectionSliders-module-scss-module__wjOECa__medvarsity_logo",
  "paytm_logo": "HeroProgramSectionSliders-module-scss-module__wjOECa__paytm_logo",
  "prgm_name": "HeroProgramSectionSliders-module-scss-module__wjOECa__prgm_name",
  "prgm_text": "HeroProgramSectionSliders-module-scss-module__wjOECa__prgm_text",
  "program_card": "HeroProgramSectionSliders-module-scss-module__wjOECa__program_card",
  "root": "HeroProgramSectionSliders-module-scss-module__wjOECa__root",
  "slide": "HeroProgramSectionSliders-module-scss-module__wjOECa__slide",
  "specialization_text": "HeroProgramSectionSliders-module-scss-module__wjOECa__specialization_text",
  "swiper_container": "HeroProgramSectionSliders-module-scss-module__wjOECa__swiper_container",
});
